import { Card, CardBody, Col } from "reactstrap";
import { SelectSizingTitle } from "../../../../../constants";
import { SelectSizingData, SelectSizingSubTitle } from "../../../../../data/formsAndTable/forms/FormControls";
import CommonSelect from "../../common/CommonSelect";
import CommonCardHeader from "../../../../../coreComponents/CommonCardHeader";

const SelectSizing = () => {
  return (
    <Col md="6">
      <Card>
        <CommonCardHeader title={SelectSizingTitle} span={SelectSizingSubTitle} />
        <CardBody>
          <CommonSelect data={SelectSizingData} inputClass="form-select-sm" labelClass="d-none" />
        </CardBody>
      </Card>
    </Col>
  );
};
export default SelectSizing;
